import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';
import * as UserService from '_services/user-service';

const initialState = {
    confirmBooking: null,
    user: null,
    status: 'idle',
    error: null
};

// get booking
export const getBooking = createAsyncThunk('confirmBooking/getBooking', async (booking_id) => {
    return BookingService.getUserBookings({booking_id});
});

// get booking for confirm booking page
export const getConfirmBooking = createAsyncThunk('confirmBooking/getBooking', async (object) => {
    return BookingService.getUserBookings(object);
});

// update booking
export const updateBooking = createAsyncThunk('confirmBooking/updateBooking', async (object) => {
    return BookingService.patchBooking(object);
});

// get info for user
export const getUser = createAsyncThunk('confirmBooking/getUser', async (object) => {
    return UserService.getUserByIdConfirmBooking(object);
});

const confirmBookingsSlice = createSlice({
    name: 'confirmBooking',
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: {
        [getBooking.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getBooking.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              confirmBooking: action.payload,
            }
        },
        [getBooking.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [getConfirmBooking.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getConfirmBooking.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              confirmBooking: action.payload,
            }
        },
        [getConfirmBooking.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [updateBooking.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [updateBooking.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              confirmBooking: action.payload,
            }
        },
        [updateBooking.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [getUser.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getUser.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              user: action.payload,
            }
        },
        [getUser.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = confirmBookingsSlice.actions;
export const selectBooking = state => state.confirmBooking.confirmBooking;
export const selectUser = state => state.confirmBooking.user;
export const selectBookingStatus = state => state.confirmBooking.status;
export default confirmBookingsSlice.reducer;
